module.exports = __webpack_public_path__ + "static/media/auth-bg-1.5249baf1.jpg";